export default __webpack_public_path__ + "static/media/rack7.71aa9a90.webp";